import { local } from 'wix-storage';
import wixLocation from 'wix-location';

$w.onReady(function () {

    $w("#searchButton").onClick((event) => {
        let word = $w("#searchWord").value;
        local.setItem("word", word);
        if (local.getItem("studies")) {
            local.removeItem("studies");
        }
        if (local.getItem("populations")) {
            local.removeItem("populations");
        }
		 if (local.getItem("regions")) {
            local.removeItem("regions");
        }
        console.log(word);
        wixLocation.to(`/research/`);
    });

    $w("#studies").onChange((event) => {
        let studies = $w("#studies").value;
        local.setItem("studies", studies);
        console.log(studies);
    });

    $w("#populations").onChange((event) => {
        let populations = $w("#populations").value;
        local.setItem("populations", populations);
        console.log(populations);
    });

    $w("#regions").onChange((event) => {
        let regions = $w("#regions").value;
        local.setItem("regions", regions);
        console.log(regions);
    });

    $w("#searchCategories").onClick((event) => {
        if (local.getItem("word")) {
            local.removeItem("word");
        }
        wixLocation.to(`/research/`);
    });

});